var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"app","position":"top center"}}),_c('router-view'),_c('select',{staticStyle:{"display":"none"},attrs:{"id":"certId"}}),(_vm.isAuthenticated)?_c('OrientationsFloatingComponents'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }